/**
 * assignment — who owns a complaint. PURE.
 *
 * Two rules the support desk runs on:
 *  1. The agent who RAISES a complaint is never its assignee. Someone else has to look
 *     at it, so a pick (or an auto-assign rule) that resolves to the creator is dropped
 *     and the ticket is left for another agent to take.
 *  2. Moving a complaint to PENDING means "I am working on this", so it transfers to
 *     whoever made that change — even if another agent held it. Every other status
 *     leaves the assignment alone.
 */

/**
 * @param {object} p
 * @param {string} p.explicitUid   assignee chosen on the form (may be empty)
 * @param {string} p.explicitName
 * @param {{uid: string, name: string}|null} p.autoRule  issue-type/department rule
 * @param {string} p.creatorUid    the agent raising the complaint
 * @returns {{assignedTo: string, assignedToName: string}}
 */
export function assigneeOnCreate({ explicitUid = '', explicitName = '', autoRule = null, creatorUid = '' } = {}) {
    const explicit = explicitUid && explicitUid === creatorUid ? '' : explicitUid;
    if (explicit) return { assignedTo: explicit, assignedToName: explicitName || '' };

    const auto = autoRule && autoRule.uid && autoRule.uid !== creatorUid ? autoRule : null;
    return { assignedTo: auto?.uid || '', assignedToName: auto?.name || '' };
}

/**
 * Should this status change hand the complaint to the person making it?
 * @param {string} status          the status being set
 * @param {string} actorUid        who is setting it
 * @param {string} currentAssignee who holds it now
 */
export function takesOwnership(status, actorUid, currentAssignee) {
    if (status !== 'pending') return false;
    if (!actorUid) return false;
    return currentAssignee !== actorUid;
}

export default { assigneeOnCreate, takesOwnership };
